<template>
  <main class="Page">
    <header>
      <picture class="image">
        <source type="image/webp" :srcset="require('@/' + webp)" />
        <img
          alt="Two people smiling in converstation with a qwello pole in the
      background"
          class="image"
          :src="require('@/' + jpg)"
        />
      </picture>
      <h1 class="title">{{ $t('process.title') }}</h1>
      <p class="question">{{ $t('process.question') }}</p>
      <p></p>
    </header>

    <Steps />
    <NetherlandsFormCTA />
  </main>
</template>
<script>
import NetherlandsFormCTA from '../../components/HomePage/NetherlandsFormCTA.vue';
import Steps from '../../components/ProcessDescriptionPage/Steps/Index.vue';

export default {
  components: {
    NetherlandsFormCTA,
    Steps,
  },
  data() {
    return {
      mobile: window.innerWidth < 768,
    };
  },
  computed: {
    jpg() {
      if (this.mobile) {
        return 'assets/processDescription/process-header.jpg';
      }
      return 'assets/processDescription/process-header.jpg';
    },
    webp() {
      if (this.mobile) {
        return 'assets/processDescription/process-header.webp';
      }
      return 'assets/processDescription/process-header.webp';
    },
  },
};
</script>
<style scoped>
.Page {
  min-height: 100vh;
  padding-top: 64px;
}
header {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
}
.title {
  grid-column: 2;
  grid-row: 1;
  font: normal normal normal 12px/20px Lato;
  letter-spacing: 1.44px;
  color: #ffffff;
  width: max-content;
  align-self: flex-end;
  width: 30ch;
  text-align: center;
}
.question {
  grid-column: 2;
  grid-row: 2;
  font: normal normal bold 30px/40px Foco;
  letter-spacing: 0px;
  color: #ffffff;
  align-self: center;
  text-align: center;
}
.image {
  grid-row: 1/-1;
  grid-column: 1/-1;
  min-height: 420px;
  object-fit: cover;
}

@media (min-width: 767px) {
  .title {
    font: normal normal normal 20px/60px Lato;
    letter-spacing: 3px;
    width: max-content;
  }
  .question {
    font: normal normal bold 70px/110px Foco;
    letter-spacing: 0px;
  }
}

@media (min-width: 1024px) {
  .Page {
    padding-top: 76px;
  }
}
</style>
